// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"Search_searchInput__w0P_t"};